import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from './Authentication/Login';
import CartPage from './cart/CartPage';
import Registration from './Authentication/Registration';
import Header from './common/Header';
import ClothRenderer from './cloth_categories/ClothRenderer';
import useStartEffect from './Custom_effects/StartEffect';
import './css/App.css'
import SuccessfulRegistration from './Authentication/SuccessfulRegistration';
import ProfilePage from './Authentication/ProfilePage';
import Product from './details/Product';
import OrderSuccess from './Payment/orderSuccess';

import Footer from "./common/Footer";
import Wishlist from './Wishlist/Wishlist';
import SearchResult from './SearchReasultPage/SearchResult';
import Homepage from './HomePage/Homepage';
import OrderPage from './orderPage/orderDetail';
import OrderItems from './orderPage/orderItems';




function App() {
 useStartEffect("start")


  return (

      <div id='mainDiv'>
        <BrowserRouter>
          <div className='header'>
            <Header/>
          </div>
          <Routes>
            <Route path="/register" element={<Registration/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/cart" element={<CartPage/>}></Route>
            <Route path='/' element={<Homepage />}></Route>
            <Route path='/SuccessfulRegistration' element={<SuccessfulRegistration/>}></Route>
            <Route path='/orderSuccess' element={<OrderSuccess/>}></Route>
            <Route path='/profile' element={<ProfilePage />} />
            <Route path='/orderPage' element={<OrderPage />} />
            <Route path='/orderItems' element={<OrderItems/>}></Route>
            <Route path="/casuals" element={<ClothRenderer link='casuals/all'/>}></Route>
            <Route path="/formals" element={<ClothRenderer link='formals/all'/>}></Route>

          <Route path="/casuals/all" element={<ClothRenderer link='casuals/all' />}></Route>
          <Route path="/casuals/shirts" element={<ClothRenderer link='casuals/shirts' />}></Route>
          <Route path="/casuals/tshirts" element={<ClothRenderer link='casuals/tshirts' />}></Route>
          <Route path="/casuals/pants" element={<ClothRenderer link='casuals/pants' />}></Route>
          <Route path="/search" element={<SearchResult link='search' />}></Route>

          <Route path="/formals/all" element={<ClothRenderer link='formals/all' />}></Route>
          <Route path="/formals/pants" element={<ClothRenderer link='formals/pants' />}></Route>
          <Route path="/formals/shirts" element={<ClothRenderer link='formals/shirts' />}></Route>

          <Route path="/product/:id" element={<Product />}></Route>

          <Route path="/wishlist" element={<Wishlist />}></Route>

        </Routes>

      
      <div className='footer'>
        <Footer />
      </div>
      </BrowserRouter>
    </div>
  );



}


export default App;